import * as yup from 'yup'

export class NeedsToBeMovedToStagingWarrantyCertPhotoDto {
  warrantyCertPhotoFileName?: string = undefined
  warrantyCertPhotoFile?: File = undefined
  parkingSpace?: string = undefined
}
